class ValidationUtils {

  static validateEmail(email) {
    const trimmed = typeof email === 'string' ? email.trim() : '';
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
    return emailRegex.test(trimmed);
  }
}

export default ValidationUtils;
